// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MenuHorizontal{margin-bottom:1.5rem}.MenuHorizontal__item,.MenuHorizontal__titleWrapper>.Title{margin-bottom:1rem}.MenuHorizontal__item>a{align-items:center;background-color:transparent;border:1px solid #eaeaea;display:flex;font-size:1rem;padding:1rem;width:100%}.MenuHorizontal__item>a:focus,.MenuHorizontal__item>a:hover{border-color:#243a88}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
